import React, { useEffect } from 'react';
import { Alert, Platform } from 'react-native';
import { CommonActions } from '@react-navigation/native';

// Navigasyon referansını tutmak için
export const navigationRef = React.createRef();

// Belirli bir ekrana gitme fonksiyonu
export const navigate = (name, params) => {
  if (navigationRef.current) {
    navigationRef.current.navigate(name, params);
  }
};

// Önceki ekrana geri dönme
export const goBack = () => {
  if (navigationRef.current) {
    navigationRef.current.goBack();
  }
};

// Son navigasyon durumunu localStorage'a kaydet (web için)
export const saveCurrentRoute = () => {
  if (Platform.OS === 'web' && navigationRef.current) {
    try {
      const state = navigationRef.current.getRootState();
      localStorage.setItem('lastNavigationState', JSON.stringify(state));
    } catch (error) {
      console.error('Navigation state kaydedilemedi:', error);
    }
  }
};

// Kaydedilmiş rotayı yükle
export const loadSavedRoute = () => {
  if (Platform.OS === 'web') {
    try {
      const savedState = localStorage.getItem('lastNavigationState');
      if (savedState) {
        const state = JSON.parse(savedState);
        return state;
      }
    } catch (error) {
      console.error('Kaydedilmiş rota yüklenemedi:', error);
    }
  }
  return null;
};

// Navigasyon durumunu sıfırla (genellikle login/logout durumlarında)
export const resetNavigation = (routeName, params = {}) => {
  if (navigationRef.current) {
    navigationRef.current.dispatch(
      CommonActions.reset({
        index: 0,
        routes: [{ name: routeName, params }],
      })
    );
  }
};

// Alert dialog helper
export const showAlert = (title, message, buttons = [{ text: 'Tamam' }]) => {
  Alert.alert(title, message, buttons, { cancelable: true });
};

// Navigasyon için ortak opsiyonlar
export const screenOptions = {
  headerStyle: {
    backgroundColor: 'rgb(125, 76, 236)',
  },
  headerTintColor: '#fff',
  headerTitleStyle: {
    fontWeight: 'bold',
  },
};
